<script lang="ts" setup>
import { Article } from '@/services/models/Article.ts'

defineProps<{
  accessory: Article
}>()
</script>

<template>
  <div :data-id="accessory.id" class="accessory-item">
    <div class="thumbnail">
      <div class="thumbnail__image-box image-box">
        <div :class="{ 'fallback-bg': !accessory.details?.pictureUrl }" class="thumbnail__image image-box__container">
          <img
            v-if="accessory.details?.pictureUrl"
            :alt="accessory.details?.name"
            :src="accessory.details?.pictureUrl"
            loading="lazy"
          >
        </div>
      </div>
    </div>

    <div class="accessory-item__description">
      <div class="accessory-item__name">
        <span>{{ accessory.details?.name }}</span>
      </div>

      <div class="accessory-item__quantity">
        <span>{{ $t('step_summary.table_accessories_quantity') }}: {{ accessory.quantity }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/style/helpers/include-media';

.accessory-item {
  display: flex;
  align-items: center;
  margin-bottom: rem-calc(8);

  &:last-child {
    margin-bottom: rem-calc(12);
  }
}
</style>
